import React, { Component } from 'react';
import { connect } from 'react-redux';
import PaymentFiltersView from './SellPaymentFilters.view';

export class PaymentFiltersContainer extends Component {
  render() {
    return (<PaymentFiltersView
      {...this.props}
    />);
  }
}

function mapStateToProps(state) {
  const { filtersFormState } = state.sellPaymentsPanel;
  return {
    filtersFormState,
  };
}

export default connect(mapStateToProps)(PaymentFiltersContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/SellPaymentsPanel/SellPaymentsModal/SellPaymentFilters/SellPaymentFilters.container.js